/**
 * Max height for auth form ScrollViews inside a center shrink-wrap card.
 * Always returns **window pixels** — never % styles (those collapse when the parent
 * has no explicit height). Tall forms scroll; short forms stay intrinsic.
 */
import { useMemo } from 'react';
import { useWindowDimensions } from 'react-native';
import { getAuthOverlayMotionForState } from './authOverlayPresentation';
import { useAuthSheets } from './authSheetContext';

/** Reserved top inset for floating close / compact card padding (no titled header). */
export const AUTH_FORM_CHROME_OFFSET_PX = 24;

/** Minimum usable scroll viewport so short devices still show fields. */
const AUTH_FORM_SCROLL_MIN_PX = 200;

export function useAuthFormScrollMaxHeight(): number {
  const { height: window_h } = useWindowDimensions();
  const { state } = useAuthSheets();

  return useMemo(() => {
    const motion = getAuthOverlayMotionForState(state);
    const fraction = motion.maxHeightFraction ?? 0.86;
    const panel_max_px = Math.round(window_h * fraction);
    return Math.max(AUTH_FORM_SCROLL_MIN_PX, panel_max_px - AUTH_FORM_CHROME_OFFSET_PX);
  }, [state, window_h]);
}
